// File: OutsourceBookkeepingServices.jsx
import React from "react";

export default function OutsourceBookkeepingServices() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Outsource Bookkeeping Services
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks provides outsourced bookkeeping for accurate financial management.
          </p>
          <p className="text-gray-700">
            Complete bookkeeping services including ledger maintenance, bank reconciliation, GST compliance, financial reporting, payroll processing, and statutory audit preparation.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: Bookkeeping services - accounting/finance professional work) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/669615/pexels-photo-669615.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Outsourced bookkeeping services - financial accounting compliance"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation handling for seamless bookkeeping operations.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Invoices and receipts</li>
                <li>Bank statements</li>
                <li>Expense records</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Confidential, accurate, compliance-driven accounting with proven expertise in Indian statutory requirements.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Confidential Financial Management
                </h3>
                <p className="text-gray-700 text-sm">
                  Secure data handling with encrypted cloud accounting, GST-compliant ledger maintenance, bank reconciliation, TDS calculations, and strict confidentiality protocols for all financial records.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate & Timely Bookkeeping
                </h3>
                <p className="text-gray-700 text-sm">
                  Precise monthly/quarterly bookkeeping, real-time financial dashboards, automated reconciliations, compliance-ready reports, audit trail maintenance, and error-free statutory filings.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Comprehensive Compliance Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Full-service accounting from Tally/QuickBooks setup through GST returns, TDS filings, payroll processing, balance sheet preparation, statutory audit coordination, and ongoing financial advisory.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
